import React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import * as Yup from "yup";
import { fr } from "yup-locales";
// import isAuthenticate from './modules/Secure/Secure'
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import "react-toastify/dist/ReactToastify.css";

// import Home from './Components/Backend/Home/Home'
import Dashboard from "./Components/Backend/IPM/Dashboard/Dashboard";
import Inscription from "./Components/Auth/Inscription";
import Connexion from "./Components/Auth/Connexion";
import ResetPassword from "./Components/Auth/ResetPassword";

import GestionSoins from "./Components/Backend/IPM/GestionSoins/GestionSoins";
import GestionBeneficiaires from "./Components/Backend/IPM/GestionBeneficiaires/GestionBeneficiaires";
import BeneficiaireProfile from "./Components/Backend/BeneficiaireProfile/BeneficiaireProfile";
import GestionTypePrestations from "./Components/Backend/IPM/GestionTypePrestations/GestionTypePrestations";
import GestionPrestataires from "./Components/Backend/IPM/GestionPrestataires/GestionPrestataires";
import GestionEntreprises from "./Components/Backend/IPM/GestionEntreprises/GestionEntreprises";
import BeneficiairesByEntreprise from "./Components/Backend/IPM/BeneficiairesByEntreprise/BeneficiairesByEntreprise";
import Parametres from "./Components/Backend/IPM/Parametres/Parametres";
import LandingPage from "./Components/LandingPage/LandingPage";
import SoinsByBeneficiaire from "./Components/Backend/IPM/SoinsByBeneficiaire/SoinsByBeneficiaire";
import GestionFacturation from "./Components/Backend/IPM/GestionFacturation/GestionFacturation";
import GestionFactures from "./Components/Backend/IPM/GestionFacturation/GestionFactures";
import DetailsFacture from "./Components/Backend/IPM/DetailsFacture/DetailsFacture";
import { DataProvider } from "./Components/store/GlobalState";
import { ToastContainer } from "react-toastify";
import GestionDemandeFicheDeSoin from "./Components/Backend/IPM/GestionDemandeFicheDeSoin/GestionDemandeFicheDeSoin";
import isAuthenticate from "./Components/Modules/Secure/Secure";

import GestionFacture from "./Components/Backend/PRESTATAIRE/GestionFacture/GestionFacture";
import ParametresPrestataire from "./Components/Backend/PRESTATAIRE/Parametres/ParametresPrestataire";
import FicheDeSoinValide from "./Components/Backend/PRESTATAIRE/FicheDeSoin/FicheDeSoinValide";

import GestionIPM from "./Components/Backend/SUPERADMIN/GestionIPM/GestionIPM";
import AdminGestionPrestataires from "./Components/Backend/SUPERADMIN/GestionPrestataires/AdminGestionPrestataires";
import AdminParametres from "./Components/Backend/SUPERADMIN/Parametres/AdminParametres";
import { getBuildDate } from "./utils/utils";
// import withClearCache from "./ClearCache";
// import GestionException from "./Components/Backend/IPM/GestionException/GestionException";
import Notification from "./Components/Backend/IPM/GestionNotifications/Notification";
import DetailPrestataire from "./Components/Backend/IPM/GestionNotifications/DetailPrestataire";
import DetailDevis from "./Components/Backend/IPM/GestionNotifications/DetailDevis";
import DetailFactureNotification from "./Components/Backend/IPM/GestionNotifications/DetailFacture";
import PrestationByPrestataire from "./Components/Backend/IPM/PrestationByPrestataire/PrestationByPrestataire";
import GestionDevis from "./Components/Backend/PRESTATAIRE/GestionDevis/GestionDevis";
import DetailEntrepriseNotification from "./Components/Backend/IPM/GestionNotifications/DetailEntrepriseNotification";
import DetailBeneficiaireNotification from "./Components/Backend/IPM/GestionNotifications/DetailBeneficiaireNotification";
import DetailAyantDroit from "./Components/Backend/IPM/GestionNotifications/DetailAyantDroit";
import Rapports from "./Components/Backend/IPM/Rapports/Rapports";
import DetailFichedesoin from "./Components/Backend/IPM/GestionNotifications/DetailFichedesoin";
// import PrestationsByBeneficiaire from "./Components/Backend/IPM/PrestationsByBeneficiaire/PrestationsByBeneficiaire";
import ChangePassword from "./Components/Backend/IPM/Parametres/ChangePassword";
import packageJson from "../package.json";
import GestionFamilleSoin from "./Components/Backend/SUPERADMIN/GestionFamilleSoin/GestionFamilleSoin";
import GestionDesExclusions from "./Components/Backend/SUPERADMIN/GestionDesExclusions/GestionDesExclusions";
import DetailsValidationExclusion from "./Components/Backend/IPM/GestionNotifications/DetailsValidationExclusion";
import GestionDesSpecialites from "./Components/Backend/SUPERADMIN/GestionDesSpecialites/GestionDesSpecialites";
import LandingPageAssurance from "./Components/Backend/Assurance/LandingpageAssurance/LandingpageAssurance";
import FirstLandingPage from "./Components/Backend/FirstLandingPage/FirstLandingPage";
import ConnexionAssureur from "./Components/Backend/Assurance/ConnexionAssureur/ConnexionAssureur";
import GestionSoinsAssureur from "./Components/Backend/Assurance/GestionSoinsAssureur/GestionSoinsAssureur";
import GestionRapportsAssureur from "./Components/Backend/Assurance/GestionRapportsAssureur/GestionRapportsAssureur";
import GestionPrestataireAssureur from "./Components/Backend/Assurance/GestionPrestataireAssureur/GestionPrestataireAssureur";
import DevisAssureur from "./Components/Backend/Assurance/AdminAssureur/DevisAssureur/DevisAssureur";
import EntrepriseAssureur from "./Components/Backend/Assurance/AdminAssureur/EntrepriseAdmin/EntrepriseAdmin";
// import FacturationAssureur from "./Components/Backend/Assurance/AdminAssureur/FacturationAdmin/FacturationAdmin";
import DetailsPrestataireAssureur from "./Components/Backend/Assurance/GestionPrestataireAssureur/DetailsPrestataireAssureur";
import FacturationClient from "./Components/Backend/Assurance/GestionFacturation/FacturationDesClients/FacturationClients";
import FacturationFournisseur from "./Components/Backend/Assurance/GestionFacturation/FacturationDesFournisseurs/FacturationFournisseur";
import PriseEnCharge from "./Components/Backend/Assurance/PriseEnCharge/PriseEnCharge";
import GestionRemboursement from "./Components/Backend/Assurance/GestionRemboursement/GestionRemboursement";
import GestionEntreprise from "./Components/Backend/Assurance/GestionEntreprise/GestionEntreprise";
import GestionAssures from "./Components/Backend/Assurance/GestionAssures/GestionAssures";
import GestionDevisAssurance from "./Components/Backend/Assurance/GestionDevis/GestionDevis";
import ParametreAssurance from "./Components/Backend/Assurance/ParametreAssurance/ParametreAssurance";
import DetailsAssures from "./Components/Backend/Assurance/GestionAssures/DetailsAssures";
import ProfilUtilisateurAssureur from "./Components/Backend/Assurance/ProfilUtilisateur/ProfilUtilisateur";
import RemboursementAssureur from "./Components/Backend/Assurance/AdminAssureur/RemboursementAssureur/RemboursementAssureur";
import AdherentAssureur from "./Components/Backend/Assurance/AdminAssureur/AdherentsAssureur/AdherentsAssureur";
import DetailsAdherent from "./Components/Backend/Assurance/AdminAssureur/AdherentsAssureur/DetailsAdherent";
import DashboardAssureur from "./Components/Backend/Assurance/DashboardAssureur/DashboardAssureur/DashboardAssureur";
import GestionPrestataireAdmin from "./Components/Backend/Assurance/AdminAssureur/GestionPrestataireAssureur/GestionPrestataireAdmin";
import DetailsPrestataireAdmin from "./Components/Backend/Assurance/AdminAssureur/GestionPrestataireAssureur/DetailsPrestataireAdmin";
import FacturationAdmin from "./Components/Backend/Assurance/AdminAssureur/FacturationAdmin/FacturationAdmin";
import DetailsFacturationAdmin from "./Components/Backend/Assurance/AdminAssureur/FacturationAdmin/DetailsFacturation";
import GestionRapportsAdmin from "./Components/Backend/Assurance/AdminAssureur/GestionRapportsAdmin/GestionRapportsAdmin";
import PriseEnChargeAdmin from "./Components/Backend/Assurance/AdminAssureur/PriseEnChargeAdmin/PriseEnChargeAdmin";
import ActiviteSoinAssureur from "./Components/Backend/Assurance/AdminAssureur/ActiviteSoinAssureur/ActiviteSoinAssureur";
import ConnexionBeneficiaire from "./Components/Backend/Beneficiaire/ConnexionBenefiaire/ConnexionBeneficiare";
import DashboardBeneficiaire from "./Components/Backend/Beneficiaire/DashboardBeneficiaire/DashboardBeneficiaire/DashboardBeneficiaire";
import FicheDeSoinsBeneficiaire from "./Components/Backend/Beneficiaire/FicheDeSoinsBeneficiaire/FicheDeSoinsBeneficiaire";
import GestionPrestataireBeneficiaire from "./Components/Backend/Beneficiaire/GestionPrestataireBeneficiaire/GestionPrestataireBeneficiaire";
import DetailsPrestataireBeneficiaire from "./Components/Backend/Beneficiaire/GestionPrestataireBeneficiaire/DetailsPrestataireBeneficiaire";
import GestionRemboursementBeneficiaire from "./Components/Backend/Beneficiaire/GestionRemboursementBeneficiaire/GestionRemboursementBeneficiaire";
import LivretBeneficiaire from "./Components/Backend/Beneficiaire/LivretBeneficiaire/LivretBeneficiaire";
import BaseDeDonneeBeneficiaire from "./Components/Backend/Beneficiaire/BaseDeDonnee/BaseDeDonnee";
import ListeDesSpecialite from "./Components/Backend/Beneficiaire/BaseDeDonnee/ListeDesSpecialite";
import Pharmacies from "./Components/Backend/Beneficiaire/BaseDeDonnee/Pharmacies";
import EtablissementSante from "./Components/Backend/Beneficiaire/BaseDeDonnee/EtablissementSante";
import InfoUtiles from "./Components/Backend/Beneficiaire/BaseDeDonnee/InfoUtiles";
import AjouterInfoUtile from "./Components/Backend/Beneficiaire/BaseDeDonnee/AjouterInfoUtile";
import DetailsInfoUtile from "./Components/Backend/Beneficiaire/BaseDeDonnee/DetailsInfoUtile";
import GestionAide from "./Components/Backend/Beneficiaire/GestionAide/GestionAide";
import NousContacter from "./Components/Backend/Beneficiaire/NousContacter/NousContacter";
import NouveauMessage from "./Components/Backend/Beneficiaire/NousContacter/NouveauMessage";
import MonCompte from "./Components/Backend/Beneficiaire/MonCompte/MonCompte";
import GestionDevisBeneficiaire from "./Components/Backend/Beneficiaire/GestionDevisBeneficiaire/GestionDevisBeneficiaire";
import GestionRendezVous from "./Components/Backend/Beneficiaire/GestionRendezVous/GestionRendezVous";
import ListeDesParticipants from "./Components/Backend/Beneficiaire/GestionRendezVous/ListeDesParticipants";
import DetailsPraticien from "./Components/Backend/Beneficiaire/GestionRendezVous/DetailsPraticien";
import GestionRendezVousPrestataire from "./Components/Backend/PRESTATAIRE/GestionRendezVousPrestataire/GestionRendezVousPrestataire";
import GestionReservation from "./Components/Backend/PRESTATAIRE/GestionReservation/GestionReservation";
import DetailsDuPrestataire from "./Components/Backend/PRESTATAIRE/GestionRendezVousPrestataire/DetailPrestataire";
import Conditions from "./Components/Backend/Condition/Conditions";
import CGU from "./Components/LandingPage/CGU";
import Policy from "./Components/LandingPage/Policy";
Yup.setLocale(fr);
// const ClearCacheComponent = withClearCache(MainApp);

// function App() {
//   return <ClearCacheComponent />;
// }

function ProtectedAuthRoute({
  children,
}) {
  const token = window.sessionStorage.getItem("authToken");
  const userType = window.sessionStorage.getItem("userType");
  let route = "/connexion"
  if (userType === "ipm" || userType === "assurance_sante" || userType === "admin_ipm") {
    route = "/ipm/dashboard"
  }


  if (userType === "entreprise") {
    route = "/entreprise/dashboard"
  }

  if (userType === "prestataire") { route = "/prestataire/dashboard" }
  if (userType === "assureur") { route = "/assurance/dashboard" }

  if (userType === "super_ipm") { route = "/admin/gestion-des-ipm" }

  if (userType === "beneficiaire") {
    route = "/dashboard-beneficiaire";
  }

  if (token) {
    return <Redirect to={route} replace />;
  }

  return children;
}

function ProtectedRouteEntr({
  children,
}) {
  const token = window.sessionStorage.getItem("authToken");
  const userType = window.sessionStorage.getItem("userType");
  let route = "/connexion"
  if (userType === "ipm" || userType === "assurance_sante" || userType === "admin_ipm") {
    route = "/ipm/dashboard"
  }

  if (userType === "prestataire") {
    route = "/prestataire/dashboard"
  }

  if (userType === "assureur") { route = "/assureur/dashboard" }
  if (userType === "beneficiaire") {
    route = "/dashboard-beneficiaire";
  }

  if (userType === "super_ipm") { route = "/admin/gestion-des-ipm" }


  if (!token) {
    return <Redirect to={"/connexion"} replace />;
  } else if (userType !== "entreprise") {
    return <Redirect to={route} replace />;
  }


  return children;
}

function ProtectedRoutePresta({
  children,
}) {
  const token = window.sessionStorage.getItem("authToken");
  const userType = window.sessionStorage.getItem("userType");
  let route = "/connexion"
  if (userType === "ipm" || userType === "assurance_sante" || userType === "admin_ipm") {
    route = "/ipm/dashboard"
  }

  if (userType === "entreprise") {
    route = "/entreprise/dashboard"
  }

  if (userType === "assureur") { route = "/assureur/dashboard" }
  if (userType === "beneficiaire") {
    route = "/dashboard-beneficiaire";
  }

  if (userType === "super_ipm") { route = "/admin/gestion-des-ipm" }


  if (!token) {
    return <Redirect to={"/connexion"} replace />;
  } else if (userType !== "prestataire") {
    return <Redirect to={route} replace />;
  }


  return children;
}

function ProtectedRouteAssureur({
  children,
}) {
  const token = window.sessionStorage.getItem("authToken");
  const userType = window.sessionStorage.getItem("userType");
  let route = "/connexion-assureur"
  if (userType === "ipm" || userType === "assurance_sante" || userType === "admin_ipm") {
    route = "/ipm/dashboard"
  }

  if (userType === "entreprise") {
    route = "/entreprise/dashboard"
  }

  if (userType === "prestataire") { route = "/prestataire/dashboard" }
  if (userType === "beneficiaire") {
    route = "/dashboard-beneficiaire";
  }

  if (userType === "super_ipm") { route = "/admin/gestion-des-ipm" }


  if (!token) {
    return <Redirect to={"/connexion-assureur"} replace />;
  } else if (userType !== "assureur") {
    return <Redirect to={route} replace />;
  }


  return children;
}

function ProtectedRouteBenef({
  children,
}) {
  const token = window.sessionStorage.getItem("authToken");
  const userType = window.sessionStorage.getItem("userType");
  let route = "/connexion"
  if (userType === "ipm" || userType === "assurance_sante" || userType === "admin_ipm") {
    route = "/ipm/dashboard"
  }


  if (userType === "entreprise") {
    route = "/entreprise/dashboard"
  }

  if (userType === "prestataire") { route = "/prestataire/dashboard" }
  if (userType === "assureur") { route = "/assurance/dashboard" }

  if (userType === "super_ipm") { route = "/admin/gestion-des-ipm" }


  if (!token) {
    return <Redirect to={"/connexion"} replace />;
  } else if (userType !== "beneficiaire") {
    return <Redirect to={route} replace />;
  }


  return children;
}

function ProtectedRouteAdmin({
  children,
}) {
  const token = window.sessionStorage.getItem("authToken");
  const userType = window.sessionStorage.getItem("userType");
  let route = "/connexion"
  if (userType === "ipm" || userType === "assurance_sante" || userType === "admin_ipm") {
    route = "/ipm/dashboard"
  }


  if (userType === "entreprise") {
    route = "/entreprise/dashboard"
  }

  if (userType === "prestataire") { route = "/prestataire/dashboard" }
  if (userType === "assureur") { route = "/assurance/dashboard" }

  if (userType === "beneficiaire") { route = "/dashboard-beneficiaire" }



  if (!token) {
    return <Redirect to={"/connexion"} replace />;
  } else if (userType !== "super_ipm") {
    return <Redirect to={route} replace />;
  }


  return children;
}

function ProtectedRouteIpm({
  children,
}) {
  const token = window.sessionStorage.getItem("authToken");
  const userType = window.sessionStorage.getItem("userType");
  let route = "/connexion";
  const isIpm = userType === "ipm" || userType === "assurance_sante" || userType === "admin_ipm";
  if (userType === "super_ipm") { route = "/admin/gestion-des-ipm" }


  if (userType === "entreprise") {
    route = "/entreprise/dashboard"
  }

  if (userType === "prestataire") { route = "/prestataire/dashboard" }
  if (userType === "assureur") { route = "/assurance/dashboard" }

  if (userType === "beneficiaire") { route = "/dashboard-beneficiaire" }


  if (!token) {
    return <Redirect to={"/connexion"} replace />;
  } else if (!isIpm) {
    return <Redirect to={route} replace />;
  }


  return children;
}


function App() {
  // var isLogInExpired = isAuthenticate();
  // const token = window.sessionStorage.getItem("authToken");
  // var userType = window.sessionStorage.getItem("userType");
  // const version = packageJson.version
  // console.log('expired', isLogInExpired)
  // console.log("Build date :", getBuildDate(packageJson.buildDate));
  return (
    <DataProvider>
      <Router>
        <div className="router-container">
          {/* <div className="version-container">
            <span> { `V${version}` } </span>
          </div> */}
          <ToastContainer />
          <Switch>
            <Route
              exact
              path="/"
              component={FirstLandingPage}
            />
            <Route
              exact
              path="/easypm"

              // render={() => {
              //   if (isLogInExpired || !token) {
              //     return <LandingPage />;
              //   } else {
              //     return (
              //       <Redirect
              //         to={
              //           userType === "ipm" ||
              //             userType === "assurance_sante" ||
              //             userType === "admin_ipm"
              //             ? "/ipm/dashboard"
              //             : userType === "entreprise"
              //               ? "/entreprise/dashboard"
              //               : userType === "prestataire"
              //                 ? "/prestataire/dashboard"
              //                 : userType === "assureur"
              //                   ? "/assurance/dashboard"
              //                   : ""
              //         }
              //       />
              //     );
              //   }
              // }}
              // component={LandingPage}
              render={() => (
                <ProtectedAuthRoute>
                  <LandingPage />
                </ProtectedAuthRoute>
              )}
            />
            {/* <Route
              exact
              path="/easypm-assurance"
              component={LandingPageAssurance}
            /> */}
            <Route
              exact
              path="/admin-assurance"
              component={DashboardAssureur}
            />
            <Route
              exact
              path="/activite-soin-assurance"
              component={ActiviteSoinAssureur}
            />
            <Route exact path="/devis-assurance" component={DevisAssureur} />
            <Route
              exact
              path="/entreprise-assurance"
              component={EntrepriseAssureur}
            />
            <Route
              exact
              path="/prestataire-assurance"
              component={GestionPrestataireAdmin}
            />
            <Route
              exact
              path="/details-prestataire-assurance/:id"
              component={DetailsPrestataireAdmin}
            />
            <Route
              exact
              path="/details-facturation-assurance/:id"
              component={DetailsFacturationAdmin}
            />
            <Route
              exact
              path="/rapports-assurance"
              component={GestionRapportsAdmin}
            />
            <Route
              exact
              path="/facturation-assurance"
              component={FacturationAdmin}
            />
            <Route
              exact
              path="/remboursement-assurance"
              component={RemboursementAssureur}
            />
            <Route
              exact
              path="/adherent-assurance"
              component={AdherentAssureur}
            />
            <Route
              exact
              path="/details-adherent-assurance/:id"
              component={DetailsAdherent}
            />
            <Route
              exact
              path="/prise-en-charge-assurance"
              component={PriseEnChargeAdmin}
            />
            <Route
              exact
              path="/conditions-generales-utilisation"
              component={CGU}
            />
            <Route
              exact
              path="/protection-des-donnees"
              component={Policy}
            />

            <Route
              exact
              path="/easypm-assurance"
              // render={() => {
              //   if (isLogInExpired || !token) {
              //     return <LandingPageAssurance />;
              //   } else {
              //     return (
              //       <Redirect
              //         to={
              //           userType === "ipm" ||
              //             userType === "assurance_sante" ||
              //             userType === "admin_ipm"
              //             ? "/ipm/dashboard"
              //             : userType === "entreprise"
              //               ? "/entreprise/dashboard"
              //               : userType === "prestataire"
              //                 ? "/prestataire/dashboard"
              //                 : userType === "assureur"
              //                   ? "/assurance/dashboard"
              //                   : ""
              //         }
              //       />
              //     );
              //   }
              // }}
              // component={LandingPageAssurance}
              render={() => (
                <ProtectedAuthRoute>
                  <LandingPageAssurance />
                </ProtectedAuthRoute>
              )}
            />

            <Route
              path="/inscription"
              // render={() => {
              //   if (isLogInExpired || !token) {
              //     return <Inscription />;
              //   } else {
              //     return (
              //       <Redirect
              //         to={
              //           userType === "ipm" ||
              //             userType === "assurance_sante" ||
              //             userType === "admin_ipm"
              //             ? "/ipm/dashboard"
              //             : userType === "entreprise"
              //               ? "/entreprise/dashboard"
              //               : userType === "prestataire"
              //                 ? "/prestataire/dashboard"
              //                 : userType === "assureur"
              //                   ? "/assurance/dashboard"
              //                   : userType === "beneficiaire"
              //                     ? "/dashboard-beneficiaire"
              //                     : ""
              //         }
              //       />
              //     );
              //   }
              // }}
              render={() => (
                <ProtectedAuthRoute>
                  <Inscription />
                </ProtectedAuthRoute>
              )}
            />

            {/* BÉNÉFICIAIRE */}
            <Route
              path="/connexion-beneficiaire"
              // component={ConnexionBeneficiaire}
              // render={() => {
              //   if (isLogInExpired || !token) {
              //     return <ConnexionBeneficiaire />;
              //   } else {
              //     return (
              //       <Redirect
              //         to={
              //           userType === "ipm" ||
              //             userType === "assurance_sante" ||
              //             userType === "admin_ipm"
              //             ? "/ipm/dashboard"
              //             : userType === "entreprise"
              //               ? "/entreprise/dashboard"
              //               : userType === "prestataire"
              //                 ? "/prestataire/dashboard"
              //                 : userType === "assureur"
              //                   ? "/assurance/dashboard"
              //                   : userType === "beneficiaire"
              //                     ? "/dashboard-beneficiaire"
              //                     : ""
              //         }
              //       />
              //     );
              //   }
              // }}
              render={() => (
                <ProtectedAuthRoute>
                  <ConnexionBeneficiaire />
                </ProtectedAuthRoute>
              )}
            />
            <Route path="/beneficiaire/change-password">
              <ProtectedRouteBenef>
                <ChangePassword />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/dashboard-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                <DashboardBeneficiaire />
              )} */}
              <ProtectedRouteBenef>
                <DashboardBeneficiaire />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/fiche-soins-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                <FicheDeSoinsBeneficiaire />
              )} */}
              <ProtectedRouteBenef>
                <FicheDeSoinsBeneficiaire />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/prestataire-agree-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                <GestionPrestataireBeneficiaire />
              )} */}
              <ProtectedRouteBenef>
                <GestionPrestataireBeneficiaire />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/detail-prestataire-beneficiaire/:id">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                <DetailsPrestataireBeneficiaire />
              )} */}
              <ProtectedRouteBenef>
                <DetailsPrestataireBeneficiaire />
              </ProtectedRouteBenef>
            </Route>

            <Route path="/remboursement-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                <GestionRemboursementBeneficiaire />
              )} */}
              <ProtectedRouteBenef>
                <GestionRemboursementBeneficiaire />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/devis-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                <GestionDevisBeneficiaire />
              )} */}
              <ProtectedRouteBenef>
                <GestionDevisBeneficiaire />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/livret-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                <LivretBeneficiaire />
              )} */}
              <ProtectedRouteBenef>
                <LivretBeneficiaire />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/base-donnee-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                <BaseDeDonneeBeneficiaire />
              )} */}
              <ProtectedRouteBenef>
                <BaseDeDonneeBeneficiaire />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/liste-des-specialites-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                <ListeDesSpecialite />
              )} */}
              <ProtectedRouteBenef>
                <ListeDesSpecialite />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/liste-des-pharmacies-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                <Pharmacies />
              )} */}
              <ProtectedRouteBenef>
                <Pharmacies />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/liste-des-etablissement-sante-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : ( */}
              <EtablissementSante />
              {/* )} */}
            </Route>
            <Route path="/info-utile-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                <InfoUtiles />
              )} */}
              <ProtectedRouteBenef>
                <InfoUtiles />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/ajouter-info-utile-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteBenef>
                <AjouterInfoUtile />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/details-info-utile-beneficiaire/:id">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteBenef>
                <DetailsInfoUtile />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/aide-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteBenef>
                <GestionAide />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/contacter-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteBenef>
                <NousContacter />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/nouveau-message-beneficiaire/:id">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteBenef>
                <NouveauMessage />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/compte-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteBenef>
                <MonCompte />
              </ProtectedRouteBenef>
            </Route>
            <Route path="/gestion-de-rendez-vous-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : ( */}
              <GestionRendezVous />
              {/* )} */}
            </Route>
            <Route path="/liste-des-participants-beneficiaire">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : ( */}
              <ListeDesParticipants />
              {/* )} */}
            </Route>
            <Route path="/details-praticiens/:id">
              {/* {isLogInExpired || !token || userType !== "beneficiaire" ? (
                <Redirect to="/connexion" />
              ) : ( */}
              <DetailsPraticien />
              {/* )} */}
            </Route>

            {/* BÉNÉFICIAIRE */}
            <Route
              path="/connexion"
              render={() => (
                <ProtectedAuthRoute>
                  <Connexion />
                </ProtectedAuthRoute>
              )}
            />
            <Route path="/connexion-assureur" render={() => (
              <ProtectedAuthRoute>
                <ConnexionAssureur />
              </ProtectedAuthRoute>
            )} />
            {/* ASSURANCE */}
            <Route path="/assurance/change-password">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <ChangePassword />
              </ProtectedRouteAssureur>
            </Route>
            <Route path="/assurance/dashboard">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <DashboardAssureur />
              </ProtectedRouteAssureur>
            </Route>
            <Route path="/assurance/soins">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <GestionSoinsAssureur />
              </ProtectedRouteAssureur>
            </Route>
            <Route path="/assurance/rapports">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <GestionRapportsAssureur />
              </ProtectedRouteAssureur>
            </Route>
            <Route exact path="/assurance/prestataire">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <GestionPrestataireAssureur />
              </ProtectedRouteAssureur>
            </Route>
            <Route path="/assurance/prestation-prestataire/:id">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <DetailsPrestataireAssureur />
              </ProtectedRouteAssureur>
            </Route>
            <Route path="/assurance/facturation-client">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <FacturationClient />
              </ProtectedRouteAssureur>
            </Route>
            <Route path="/assurance/facturation-fournisseur">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <FacturationFournisseur />
              </ProtectedRouteAssureur>
            </Route>
            <Route path="/assurance/prise-en-charge">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <PriseEnCharge />
              </ProtectedRouteAssureur>
            </Route>
            <Route path="/assurance/remboursement">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <GestionRemboursement />
              </ProtectedRouteAssureur>
            </Route>
            <Route path="/assurance/entreprise">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <GestionEntreprise />
              </ProtectedRouteAssureur>
            </Route>
            <Route path="/assurance/assures">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <GestionAssures />
              </ProtectedRouteAssureur>
            </Route>
            <Route path="/assurance/devis">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <GestionDevisAssurance />
              </ProtectedRouteAssureur>
            </Route>
            <Route path="/assurance/parametre">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <ParametreAssurance />
              </ProtectedRouteAssureur>
            </Route>
            <Route path="/assurance/details-assures/:id">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <DetailsAssures />
              </ProtectedRouteAssureur>
            </Route>
            <Route path="/assurance/profil">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion-assureur" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <ProfilUtilisateurAssureur />
              </ProtectedRouteAssureur>
            </Route>
            <Route path="/assurance/notification/:id">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <Notification />
              </ProtectedRouteAssureur>
            </Route>

            <Route path="/assurance/prestation-validation">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <DetailsValidationExclusion />
              </ProtectedRouteAssureur>
            </Route>

            <Route path="/assurance/beneficiaire/:id">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <DetailBeneficiaireNotification />
              </ProtectedRouteAssureur>
            </Route>

            <Route path="/assurance/ayantdroit/:id">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <DetailAyantDroit />
              </ProtectedRouteAssureur>
            </Route>

            <Route path="/assurance/prestataire/:id">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <DetailPrestataire />
              </ProtectedRouteAssureur>
            </Route>

            <Route path="/assurance/facture/:id">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <DetailFactureNotification />
              </ProtectedRouteAssureur>
            </Route>

            <Route path="/assurance/devis/:id">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAssureur>
                <DetailDevis />
              </ProtectedRouteAssureur>
            </Route>

            <Route path="/assurance/fichedesoin/:id">
              {/* {isLogInExpired || !token || userType !== "assureur" ? (
                <Redirect to="/connexion" />
              ) : (
               
              )} */}
              <ProtectedRouteAssureur>
                <DetailFichedesoin />
              </ProtectedRouteAssureur>
            </Route>
            {/* IPM */}

            <Route path="/ipm/dashboard">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <Dashboard />
              </ProtectedRouteIpm>
            </Route>
            <Route
              path="/modifier-mon-mot-de-passe"
              component={ResetPassword}
            />
            {/* <Route path="/listing" component={Listing} /> */}
            <Route path="/ipm/gestion-des-remboursements">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <GestionSoins />
              </ProtectedRouteIpm>
            </Route>
            <Route path="/ipm/gestion-des-beneficiaires">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <GestionBeneficiaires />
              </ProtectedRouteIpm>
            </Route>
            <Route path="/ipm/profil-beneficiaire/:id">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <BeneficiaireProfile />
              </ProtectedRouteIpm>
            </Route>
            <Route path="/ipm/gestion-des-types-de-prestation">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <GestionTypePrestations />
              </ProtectedRouteIpm>
            </Route>
            <Route path="/ipm/gestion-des-prestataires">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <GestionPrestataires />
              </ProtectedRouteIpm>
            </Route>
            <Route path="/ipm/gestion-des-entreprises">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <GestionEntreprises />
              </ProtectedRouteIpm>
            </Route>
            <Route path="/ipm/beneficiaires-entreprise/:id">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <BeneficiairesByEntreprise />
              </ProtectedRouteIpm>
            </Route>
            <Route path="/ipm/prestation-prestataire/:id">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <PrestationByPrestataire />
              </ProtectedRouteIpm>
            </Route>
            {/* <Route path="/ipm/soins-beneficiaire/:id" >
              {(isLogInExpired || !token) || (userType !== "ipm" ||
                        userType === "assurance_sante" ||
                        userType === "admin_ipm") ? <Redirect to='/connexion' /> : <PrestationsByBeneficiaire/>}
            </Route> */}
            <Route path="/ipm/parametres">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <Parametres />
              </ProtectedRouteIpm>
            </Route>
            <Route path="/ipm/change-password">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <ChangePassword />
              </ProtectedRouteIpm>
            </Route>
            {/* <Route path="/ipm/soins-beneficiaire/:beneficiaireID" >
              {(isLogInExpired || !token) || (userType !== "ipm" ||
                        userType === "assurance_sante" ||
                        userType === "admin_ipm") ? <Redirect to='/connexion' /> : <SoinsByBeneficiaire />}
            </Route> */}
            <Route path="/ipm/gestion-de-la-facturation">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <GestionFacturation />
              </ProtectedRouteIpm>
            </Route>
            <Route path="/ipm/gestion-des-factures">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <GestionFactures />
              </ProtectedRouteIpm>
            </Route>

            {/* <Route path="/ipm/gestion-des-exceptions" >
              {(isLogInExpired || !token) || (userType !== "ipm" ||
                        userType === "assurance_sante" ||
                        userType === "admin_ipm") ? <Redirect to='/connexion' /> : <GestionException />}
            </Route> */}
            <Route path="/ipm/gestion-des-devis">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
               
              )} */}
              <ProtectedRouteIpm>
                <GestionDevis />
              </ProtectedRouteIpm>
            </Route>
            <Route path="/ipm/details-facture/:entrepriseID">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <DetailsFacture />
              </ProtectedRouteIpm>
            </Route>
            <Route path="/ipm/gestion-des-fiches-de-soin">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <GestionDemandeFicheDeSoin />
              </ProtectedRouteIpm>
            </Route>

            <Route path="/ipm/rapports">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <Rapports />
              </ProtectedRouteIpm>
            </Route>

            <Route path="/ipm/notification/:id">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <Notification />
              </ProtectedRouteIpm>
            </Route>

            <Route path="/ipm/prestation-validation">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <DetailsValidationExclusion />
              </ProtectedRouteIpm>
            </Route>

            <Route path="/ipm/beneficiaire/:id">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <DetailBeneficiaireNotification />
              </ProtectedRouteIpm>
            </Route>

            <Route path="/ipm/ayantdroit/:id">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <DetailAyantDroit />
              </ProtectedRouteIpm>
            </Route>

            <Route path="/ipm/prestataire/:id">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <DetailPrestataire />
              </ProtectedRouteIpm>
            </Route>

            <Route path="/ipm/facture/:id">
              {/* {isLogInExpired ||
                !token ||
                (userType !== "ipm" &&
                  userType !== "assurance_sante" &&
                  userType !== "admin_ipm") ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <DetailFactureNotification />
              </ProtectedRouteIpm>
            </Route>

            <Route path="/ipm/devis/:id">
              {/* {isLogInExpired ||
                !token ||
                userType !== "ipm" ||
                userType === "assurance_sante" ||
                userType === "admin_ipm" ? (
                <Redirect to="/connexion" />
              ) : (
               
              )} */}
              <ProtectedRouteIpm>
                <DetailDevis />
              </ProtectedRouteIpm>
            </Route>

            <Route path="/ipm/fichedesoin/:id">
              {/* {isLogInExpired ||
                !token ||
                userType !== "ipm" ||
                userType === "assurance_sante" ||
                userType === "admin_ipm" ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteIpm>
                <DetailFichedesoin />
              </ProtectedRouteIpm>
            </Route>

            {/* ENTREPRISES */}
            <Route path="/entreprise/dashboard">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteEntr>
                <Dashboard />
              </ProtectedRouteEntr>
            </Route>
            <Route path="/entreprise/gestion-des-employes">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteEntr>
                <GestionBeneficiaires />
              </ProtectedRouteEntr>
            </Route>
            <Route path="/entreprise/profil-employes/:id">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteEntr>
                <BeneficiaireProfile />
              </ProtectedRouteEntr>
            </Route>
            <Route path="/entreprise/liste-des-prestataires">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteEntr>
                <GestionPrestataires />
              </ProtectedRouteEntr>
            </Route>
            <Route path="/entreprise/notification/:id">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteEntr>
                <Notification />
              </ProtectedRouteEntr>
            </Route>
            <Route path="/entreprise/gestion-des-factures">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteEntr>
                <GestionFactures />
              </ProtectedRouteEntr>
            </Route>
            <Route path="/entreprise/gestion-des-remboursements">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteEntr>
                <GestionSoins />
              </ProtectedRouteEntr>
            </Route>
            <Route path="/entreprise/gestion-des-devis">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteEntr>
                <GestionDevis />
              </ProtectedRouteEntr>
            </Route>
            <Route path="/entreprise/prestation-prestataire/:id">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteEntr>
                <PrestationByPrestataire />
              </ProtectedRouteEntr>
            </Route>
            <Route path="/entreprise/facture/:id">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteEntr>
                <DetailFactureNotification />
              </ProtectedRouteEntr>
            </Route>
            <Route path="/entreprise/beneficiaire/:id">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteEntr>
                <DetailBeneficiaireNotification />
              </ProtectedRouteEntr>
            </Route>
            <Route path="/entreprise/devis/:id">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteEntr>
                <DetailDevis />
              </ProtectedRouteEntr>
            </Route>
            <Route path="/entreprise/parametres">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteEntr>
                <Parametres />
              </ProtectedRouteEntr>
            </Route>
            <Route path="/entreprise/change-password">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteEntr>
                <ChangePassword />
              </ProtectedRouteEntr>
            </Route>
            <Route path="/entreprise/rapports">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteEntr>
                <Rapports />
              </ProtectedRouteEntr>
            </Route>

            {/* PRESTATAIRE */}
            <Route path="/prestataire/gestion-des-factures">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRoutePresta>
                <GestionFacture />
              </ProtectedRoutePresta>
            </Route>
            <Route path="/prestataire/dashboard">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRoutePresta>
                <Dashboard />
              </ProtectedRoutePresta>
            </Route>
            <Route path="/prestataire/fiche-de-soin-valide">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRoutePresta>
                <FicheDeSoinValide />
              </ProtectedRoutePresta>
            </Route>
            <Route path="/prestataire/profil-beneficiaire/:id">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRoutePresta>
                <BeneficiaireProfile />
              </ProtectedRoutePresta>
            </Route>
            {/* <Route path="/prestataire/adherents" >
              {(isLogInExpired || !token) ? <Redirect to='/connexion' /> : <GestionBeneficiaires />}
            </Route> */}
            <Route path="/prestataire/gestion-des-devis">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRoutePresta>
                <GestionDevis />
              </ProtectedRoutePresta>
            </Route>
            <Route path="/prestataire/devis/:id">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRoutePresta>
                <DetailDevis />
              </ProtectedRoutePresta>
            </Route>
            <Route path="/prestataire/parametres">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRoutePresta>
                <ParametresPrestataire />
              </ProtectedRoutePresta>
            </Route>
            <Route path="/prestataire/gestion-des-rdv">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRoutePresta>
                <GestionRendezVousPrestataire />
              </ProtectedRoutePresta>
            </Route>
            <Route path="/prestataire/details-prestataire/:id">
              <ProtectedRoutePresta>
                <DetailsDuPrestataire />
              </ProtectedRoutePresta>

            </Route>
            <Route path="/prestataire/gestion-des-reservations">
              <ProtectedRoutePresta>
                <GestionReservation />
              </ProtectedRoutePresta>
            </Route>
            <Route path="/prestataire/change-password">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRoutePresta>
                <ChangePassword />
              </ProtectedRoutePresta>
            </Route>

            <Route path="/prestataire/facture/:id">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRoutePresta>
                <DetailFactureNotification />
              </ProtectedRoutePresta>
            </Route>

            {/* SUPER ADMIN */}
            {/* <Route path="/admin/dashboard" >
              {(isLogInExpired || !token) ? <Redirect to='/connexion' /> : <Dashboard />}
            </Route> */}
            <Route path="/admin/gestion-des-ipm">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAdmin>
                <GestionIPM />
              </ProtectedRouteAdmin>
            </Route>
            <Route path="/admin/gestion-des-etablissements-et-pharmacies">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAdmin>
                <AdminGestionPrestataires />
              </ProtectedRouteAdmin>
            </Route>
            <Route path="/admin/gestion-des-familles-soins">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAdmin>
                <GestionFamilleSoin />
              </ProtectedRouteAdmin>
            </Route>
            <Route path="/admin/gestion-des-exclusions">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAdmin>
                <GestionDesExclusions />
              </ProtectedRouteAdmin>
            </Route>
            <Route path="/admin/conditions">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAdmin>
                <Conditions />
              </ProtectedRouteAdmin>
            </Route>
            <Route path="/admin/parametres">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAdmin>
                <AdminParametres />
              </ProtectedRouteAdmin>
            </Route>
            <Route path="/admin/prestataire/:id">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
               
              )} */}
              <ProtectedRouteAdmin>
                <DetailPrestataire />
              </ProtectedRouteAdmin>
            </Route>

            <Route path="/admin/entreprise/:id">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAdmin>
                <DetailEntrepriseNotification />
              </ProtectedRouteAdmin>
            </Route>

            <Route path="/admin/beneficiaire/:id">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAdmin>
                <DetailBeneficiaireNotification />
              </ProtectedRouteAdmin>
            </Route>
            <Route path="/admin/change-password">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAdmin>
                <ChangePassword />
              </ProtectedRouteAdmin>
            </Route>
            <Route path="/admin/gestion-des-specialites">
              {/* {isLogInExpired || !token ? (
                <Redirect to="/connexion" />
              ) : (
                
              )} */}
              <ProtectedRouteAdmin>
                <GestionDesSpecialites />
              </ProtectedRouteAdmin>
            </Route>
          </Switch>
        </div>
      </Router>
    </DataProvider>
  );
}

export default App;
